/* Halo Finds — product page (sections/main-product) */
(function () {
  function init(root) {
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';
  var data = JSON.parse(root.querySelector('[data-pdp-json]').textContent);
  var product = data.product;
  var moneyFormat = data.moneyFormat || ('$' + '{' + '{amount}' + '}');

  function fmt(cents, noZeros) {
    cents = Number(cents || 0);
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var wholeDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var dec = (noZeros && parts[1] === '00') ? '' : '.' + parts[1];
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return whole;
        case 'amount_with_comma_separator': return wholeDot + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return wholeDot;
        default: return whole + dec;
      }
    });
  }

  /* ---------- Recently viewed (used by the "Recently viewed" section) ---------- */
  try {
    var rv = JSON.parse(localStorage.getItem('halo-recent') || '[]').filter(function (h) { return h !== product.handle; });
    rv.unshift(product.handle);
    localStorage.setItem('halo-recent', JSON.stringify(rv.slice(0, 12)));
  } catch (e) {}

  /* ---------- Gallery ---------- */
  var viewport = root.querySelector('[data-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('.pdp__slide'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  var thumbsWrap = root.querySelector('[data-thumbs]');
  var counter = root.querySelector('[data-counter]');
  var prev = root.querySelector('[data-prev]');
  var next = root.querySelector('[data-next]');
  var current = 0;

  function goTo(i, smooth) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    viewport.scrollTo({ left: i * viewport.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    setActive(i);
  }
  function setActive(i) {
    current = i;
    thumbs.forEach(function (t, x) { t.classList.toggle('is-active', x === i); });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
    var t = thumbs[i];
    if (t && thumbsWrap) {
      var left = t.offsetLeft - (thumbsWrap.clientWidth - t.clientWidth) / 2;
      thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
    }
  }
  var scrollTimer;
  viewport && viewport.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
      if (i !== current) setActive(i);
    }, 60);
  }, { passive: true });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.thumb)); }); });
  prev && prev.addEventListener('click', function () { goTo(current - 1); });
  next && next.addEventListener('click', function () { goTo(current + 1); });
  viewport && viewport.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });
  window.addEventListener('resize', function () { goTo(current, false); });
  setActive(0);

  /* ---------- Lightbox ---------- */
  var lb = root.querySelector('[data-lightbox]');
  if (lb) {
    var lbImg = lb.querySelector('[data-lb-img]');
    var zoomables = slides.map(function (s) { var im = s.querySelector('img[data-zoom]'); return im ? im.dataset.zoom : null; });
    var lbIndex = 0;
    function lbShow(i) {
      var list = zoomables.map(function (z, x) { return z ? x : -1; }).filter(function (x) { return x > -1; });
      if (!list.length) return;
      if (zoomables[i] == null) i = list[0];
      lbIndex = i;
      lbImg.src = zoomables[i];
    }
    function lbStep(d) {
      var i = lbIndex;
      for (var k = 0; k < zoomables.length; k++) { i = (i + d + zoomables.length) % zoomables.length; if (zoomables[i]) break; }
      lbShow(i);
    }
    function lbOpen() { lbShow(current); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; lb.querySelector('[data-lb-close]').focus(); }
    function lbClose() { lb.hidden = true; document.documentElement.style.overflow = ''; }
    root.querySelectorAll('[data-zoom-open]').forEach(function (b) { b.addEventListener('click', lbOpen); });
    slides.forEach(function (s) { var im = s.querySelector('img[data-zoom]'); if (im) im.addEventListener('click', lbOpen); });
    lb.querySelector('[data-lb-close]').addEventListener('click', lbClose);
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { lbStep(-1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { lbStep(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbStep(-1);
      if (e.key === 'ArrowRight') lbStep(1);
    });
  }

  /* ---------- Show all values ---------- */
  root.querySelectorAll('[data-more]').forEach(function (btn) {
    var fs = btn.closest('.pdp__option');
    var label = btn.querySelector('[data-more-label]');
    var total = fs.querySelectorAll('.pdp__value').length;
    btn.addEventListener('click', function () {
      var open = fs.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? data.showLess : data.showAll.replace('[count]', total);
    });
  });

  /* ---------- Variants ---------- */
  var form = root.querySelector('[data-product-form]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var saveEl = root.querySelector('[data-save]');
  var badgeEl = root.querySelector('[data-badge]');
  var addBtn = root.querySelector('[data-add]');
  var addLabel = root.querySelector('[data-add-label]');
  var errorEl = root.querySelector('[data-error]');
  var stockEl = root.querySelector('[data-stock]');
  var sticky = root.querySelector('[data-sticky]');
  var optionCount = (product.options || []).length;

  function selectedOptions() {
    var vals = [];
    for (var i = 0; i < optionCount; i++) {
      var radio = root.querySelector('[data-option-radio="' + i + '"]:checked');
      vals.push(radio ? radio.value : null);
    }
    return vals;
  }
  function findVariant(opts) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
    });
  }
  function markAvailability(opts) {
    for (var i = 0; i < optionCount; i++) {
      root.querySelectorAll('[data-option-radio="' + i + '"]').forEach(function (input) {
        var test = opts.slice(); test[i] = input.value;
        var match = findVariant(test);
        input.closest('.pdp__value').classList.toggle('is-unavailable', !match || !match.available);
      });
    }
  }
  function saveText(v) {
    var diff = v.compare_at_price - v.price;
    var pct = Math.round(diff * 100 / v.compare_at_price);
    if (data.saveFormat === 'amount') return data.saveLabel + ' ' + fmt(diff, true);
    if (data.saveFormat === 'both') return data.saveLabel + ' ' + fmt(diff, true) + ' (' + pct + '%)';
    return data.saveLabel + ' ' + pct + '%';
  }
  function update() {
    var opts = selectedOptions();
    var v = findVariant(opts);
    for (var i = 0; i < optionCount; i++) {
      var label = root.querySelector('[data-option-selected="' + i + '"]');
      if (label) label.textContent = opts[i];
    }
    markAvailability(opts);
    errorEl.hidden = true;
    if (!v) {
      addBtn.disabled = true; addLabel.textContent = data.unavailLabel;
      syncSticky(null);
      return;
    }
    idInput.value = v.id;
    priceEl.textContent = fmt(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    priceEl.classList.toggle('is-sale', !!onSale);
    compareEl.hidden = !onSale;
    saveEl.hidden = !onSale;
    if (badgeEl) { badgeEl.hidden = !onSale; if (onSale) badgeEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
    if (onSale) { compareEl.textContent = fmt(v.compare_at_price); saveEl.textContent = saveText(v); }
    addBtn.disabled = !v.available;
    addLabel.textContent = v.available ? data.addLabel : data.soldLabel;
    if (stockEl) {
      var q = data.inventory[v.id];
      var low = v.available && q != null && q > 0 && q <= data.lowStockAt;
      stockEl.hidden = !low;
      if (low) stockEl.querySelector('[data-stock-text]').textContent = data.lowStockText.replace('[count]', q);
    }
    if (v.featured_media) {
      var idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(v.featured_media.id); });
      if (idx > -1) goTo(idx);
    }
    syncSticky(v);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-radio]')) update();
  });
  if (optionCount && !product.has_only_default_variant) markAvailability(selectedOptions());

  /* ---------- Quantity ---------- */
  var qty = root.querySelector('[data-qty-input]');
  root.querySelector('[data-qty-minus]').addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  root.querySelector('[data-qty-plus]').addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  /* ---------- Delivery estimate ---------- */
  var del = root.querySelector('[data-delivery]');
  if (del) {
    var skipWk = root.dataset.skipWeekends === 'true';
    var addDays = function (n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (!skipWk || (d.getDay() !== 0 && d.getDay() !== 6)) n--; }
      return d;
    };
    var f = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    del.textContent = f(addDays(Number(root.dataset.deliveryMin) || 9)) + ' – ' + f(addDays(Number(root.dataset.deliveryMax) || 14));
  }

  /* ---------- Share ---------- */
  var shareBtn = root.querySelector('[data-share]');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    var u = shareBtn.dataset.url, t = shareBtn.dataset.title, lab = shareBtn.querySelector('[data-share-label]');
    if (navigator.share) { navigator.share({ title: t, url: u }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(u).then(function () { lab.textContent = 'Link copied'; setTimeout(function () { lab.textContent = 'Share'; }, 2000); });
  });

  /* ---------- Sticky add to cart ---------- */
  function syncSticky(v) {
    if (!sticky) return;
    var b = sticky.querySelector('[data-sticky-add]');
    var l = sticky.querySelector('[data-sticky-label]');
    if (!v) { b.disabled = true; l.textContent = data.unavailLabel; return; }
    sticky.querySelector('[data-sticky-price]').textContent = fmt(v.price);
    var c = sticky.querySelector('[data-sticky-compare]');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    c.hidden = !onSale; if (onSale) c.textContent = fmt(v.compare_at_price);
    b.disabled = !v.available; l.textContent = v.available ? data.addLabel : data.soldLabel;
    var img = sticky.querySelector('[data-sticky-img]');
    if (img && v.featured_image) img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  if (sticky) {
    var buy = root.querySelector('[data-buy]');
    if ('IntersectionObserver' in window && buy) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('[data-sticky-add]').tabIndex = show ? 0 : -1;
      }).observe(buy);
    }
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn.click();
    });
  }

  /* ---------- Add to cart (opens the cart drawer) ---------- */
  form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    addBtn.classList.add('is-loading');
    errorEl.hidden = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      addBtn.classList.remove('is-loading');
      if (!r.ok) {
        errorEl.textContent = r.body.description || r.body.message || 'Could not add to cart.';
        errorEl.hidden = false;
        return;
      }
      if (window.HaloCart) window.HaloCart.refresh().then(window.HaloCart.open);
      else window.location.href = '/cart';
    }).catch(function () {
      addBtn.classList.remove('is-loading');
      form.submit();
    });
  });
  }
  document.querySelectorAll('[data-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-pdp]').forEach(init); });
})();
